import { Map } from 'immutable';
import { actionTypes as EditPreferenceDialogActions } from '../../../actions/Administration/SettingsPage/Dialogs/editPreferenceDialogActions';

let defaultState = {
  show: false,
  loading: false,
  itemToEdit: null,
  dialogData: null,
};

export default function(state = Map(defaultState), action) {

  switch (action.type) {
    case EditPreferenceDialogActions.EDIT_PREFERENCE_DIALOG_SHOW:
      state = state.set('itemToEdit', action.payload);
      return state.set('show',true);

    case EditPreferenceDialogActions.EDIT_PREFERENCE_DIALOG_HIDE:
      return Map(defaultState);

    case EditPreferenceDialogActions.EDIT_PREFERENCE_DIALOG_SUBMIT_IN_PROGRESS:
      return state.set("loading", true);

    case EditPreferenceDialogActions.EDIT_PREFERENCE_DIALOG_SUBMIT_FINISHED:
      return state.set("loading", false);

    case EditPreferenceDialogActions.EDIT_PREFERENCE_DIALOG_FETCH_DATA_READY:
      return state.set("dialogData", action.payload);

    default:
      return state;
  }

}







